
import api from '@/plugins/api'
import MapStyle from "./mapStyle";
import { mapState, mapMutations } from "vuex";
import { openUrl } from '~/plugins/util'
let ZoomControl = null;
export default {
  props: {
    cluPic: {
      type: String,
      default: "//static.buwangchuxin.com/red_open_palm/image/icon/clu-story.png"
    },
    markerPic: {
      type: Object,
      default: () => {}
    },
    apiInfo: Object
  },
  data() {
    return {
      timer: null,
      mapData: [],
      clusterStyle: {
        // url: this.cluPic,
        // size: new BMap.Size(42, 63),
        // textColor: "#fb3336",
        // textSize: 13
      },
      differMarksList: [],
      markers: [],
      labels: [],
      markerClusterer: null,
      ifSetCenter: true, // 是否设置地图中心点
      currentSelectLabel: "",
      changeType: false, // 切换类型
      polygon: null // 赣州市边界路径
    };
  },
  computed: {
    ...mapState(['baseUrl']),
    type() {
      return this.$store.state.map.obj.type;
    },
    name() {
      return this.$store.state.map.obj.name;
    }
  },
  mounted() {
    ZoomControl = function() {
        // 设置默认停靠位置和偏移量
        this.defaultAnchor = BMAP_ANCHOR_BOTTOM_RIGHT;
        this.defaultOffset = new BMap.Size(10, 10);
    }
    this.initMap();
  },
  methods: {
    ...mapMutations("map", ["setMapInfoObj"]),

    // 地图初始化
    initMap() {
      this.setMapInfoObj({
        name: this.name,
        type: this.type
      });

      this.clusterStyle = {
        url: this.cluPic,
        size: new BMap.Size(42, 63),
        textColor: "#fb3336",
        textSize: 13
      }
      let map = new BMap.Map("map", {
        enableMapClick: true,
        minZoom: 5,
        maxZoom: 20
      });

      map.enableScrollWheelZoom(true);
      this.createControl();
      var myZoomCtrl = new ZoomControl();
      map.addControl(myZoomCtrl);

      map.centerAndZoom(new BMap.Point(114.94001647, 25.83635), 10);

      // 初始化打点数据
      this.markers = [];
      this.labels = [];

      // 初始化点聚合  BMapLib.TextIconOverlay
      this.markerClusterer = new BMapLib.MarkerClusterer(map, {
        labels: this.labels,
        markers: this.markers,
        maxZoom: 20,
        minClusterSize: 5,
        styles: [this.clusterStyle]
      });

      map.addEventListener("dragend", () => {
        if (this.name || this.type > 3) return;
        this.getData(true);
      });

      map.addEventListener("zoomend", () => {
        if (this.name || this.changeType || this.type > 3) return;
        this.getData(true);
      });

      // 区域描边
      const that = this;
      new BMap.Boundary().get("赣州市", function(rs) {
        that.polygon = new BMap.Polygon(rs.boundaries[0], {
          strokeWeight: 3,
          strokeColor: "#c00",
          fillColor: ""
        });
        map.addOverlay(that.polygon);
        // map.setViewport(that.polygon.getPath());
        // map.setZoom(10);
      });

      this.map = map;
      const styles = MapStyle;
      map.setMapStyleV2({
        styleJson: styles
      });
      this.getData(true);
    },
    
    // 控件
    createControl() {
      let _this = this;
      ZoomControl.prototype = new BMap.Control();
      ZoomControl.prototype.initialize = function (map) {
          //创建一个DIV
          var mydiv = document.createElement('div');
          mydiv.setAttribute('class', 'map-control');

          //创建一个定位用的img
          var img_location = document.createElement('img');
          img_location.setAttribute('src', _this.baseUrl + '/web/map/static/image/icon/mapLocation.png');
          img_location.setAttribute('title', '定位到您当前城市');
          img_location.onclick = function () {
              function myFun(result) {
                  var cityName = result.name;
                  map.setCenter(cityName);
              }
              var myCity = new BMap.LocalCity();
              myCity.get(myFun);
          };

          //创建一个放大用的img
          var img_plus = document.createElement('img');
          img_plus.setAttribute('src', _this.baseUrl + '/web/map/static/image/icon/mapLarge.png');
          img_plus.setAttribute('title', '放大一级');
          img_plus.onclick = function () {
              map.zoomTo(map.getZoom() + 1);
          };

          //创建一个缩小用的img
          var img_minus = document.createElement('img');
          img_minus.setAttribute('src', _this.baseUrl + '/web/map/static/image/icon/mapSmall.png');
          img_minus.setAttribute('title', '缩小一级');
          img_minus.onclick = function () {
              map.zoomTo(map.getZoom() - 1);
          };

          mydiv.appendChild(img_location);
          mydiv.appendChild(document.createElement('br'));

          mydiv.appendChild(img_plus);
          mydiv.appendChild(document.createElement('br'));

          mydiv.appendChild(img_minus);
          map.getContainer().appendChild(mydiv);

          return mydiv;
      };
    },

    // viewport是否随着视口变化请求数据
    getData(viewport = false) {
      this.changeType = false;
      const params = {
        tab: this.type
      };
      const zm = this.map.getZoom();
      if (viewport) {
        const bs = this.map.getBounds();
        const sw = bs.getSouthWest();
        const ne = bs.getNorthEast();
        params.right_top_lng = ne.lng;
        params.right_top_lat = ne.lat;
        params.left_bottom_lng = sw.lng;
        params.left_bottom_lat = sw.lat;
      }
      if (this.name) {
        params.name = this.name;
      }
      // params.zoom = zm; //newdo去除了zoom
      this.mapData = [];
      this.$axios.$post(api.getPoint, params)
      .then(data => {
        this.mapData = data.list;
          let len = data.list.length;
          for (let i = 0; i < len; i++) {
            data.list[i].type = params.tab;
          }

          this.addMaker(data.list);
          if (!this.ifSetCenter || !this.name) return;

          if (this.mapData.length > 1) {
            const centerPoint = this.getCenterPointFromListOfCoordinates(
              this.mapData
            );
            this.map.centerAndZoom(
              new BMap.Point(centerPoint.lng, centerPoint.lat),
              10
            );
          } else if (this.mapData.length === 1) {
            this.map.centerAndZoom(
              new BMap.Point(this.mapData[0].lng, this.mapData[0].lat),
              12
            );
          }
      }).catch(err => {
          this.$message.error(err || '啊哦~网络走丢了, 请稍后再试！');
      })
    },

    arrayGroup(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
      }
      return newArray;
    },

    addMaker(datas) {
      let data = datas;
      if (data.length > 1000) {
        const splitData = this.arrayGroup(data, 1000);
        this.renderMarke(splitData);
      } else {
        this.renderMarke(data);
      }
    },
    getCenterPointFromListOfCoordinates(coordinateList) {
      const total = coordinateList.length;
      let X = 0;
      let Y = 0;
      let Z = 0;
      coordinateList.forEach(coordinate => {
        var lat = (coordinate.lat * Math.PI) / 180;
        var lon = (coordinate.lng * Math.PI) / 180;
        X += Math.cos(lat) * Math.cos(lon);
        Y += Math.cos(lat) * Math.sin(lon);
        Z += Math.sin(lat);
      });
      X = X / total;
      Y = Y / total;
      Z = Z / total;
      const lon2 = Math.atan2(Y, X);
      const hyp = Math.sqrt(X * X + Y * Y);
      const lat2 = Math.atan2(Z, hyp);
      const coordinate2 = {};
      coordinate2.lng = (lon2 * 180) / Math.PI;
      coordinate2.lat = (lat2 * 180) / Math.PI;
      return coordinate2;
    },

    /** marker图标 */
    getIconPath(item) {
      let type = this.type;
      if (this.type == 4) {
        switch (item.place_type) {
          case 0:
            type = 1;
            break;
          case 1:
          case 2:
            type = 2;
            break;
          case 3:
            type = 3;
            break;
        }
      } else if (this.type == 5) type = 1;
      return this.markerPic[type];
    },

    renderMarke(datas) {
      const map = this.map;
      let markerlist = datas;
      
      if (Array.isArray(datas[0])) {
        markerlist = datas[0];
        const nextData = datas.slice(1);
        this.timer = setTimeout(() => {
          this.renderMarke(nextData);
        });
      }
      this.markers = [];
      this.labels = [];
      let tipItem = "";

      markerlist.forEach((item, index) => {
        if (!item.name && this.type < 4) return true; //continue
        if (item.type != this.type) return; //解决类型切换时maker遗留上个类型数据

        /*
         * 之前地图卡顿的主要原因，marker重复渲染，查重过程
         * 获取到的数据多为重复数据，地图上已经渲染，无需每次清除再全部重新渲染
         * 若有性能更高方案，请替换
         * */
        let rendered = this.differMarksList.find(x => {
          return x.id === item.id && item.name !== this.name;
        });
        if (rendered) {
          return;
        } else {
          this.differMarksList.push(item);
        }
        /*
         * 截至查重
         * */
        const iconPath = this.getIconPath(item);
        const point = new BMap.Point(item.lng, item.lat);
        const icon = new BMap.Icon(iconPath, new BMap.Size(42, 84), {
          imageSize: new BMap.Size(42, 84)
        });

        const marker = new BMapLib.TextIconOverlay(point, "", {
          styles: [
            {
              url: iconPath,
              size: new BMap.Size(42, 84),
              textColor: "rgba(0,0,0,0)"
            }
          ]
        });
        this.markers.push(marker);

        // map.addOverlay(marker); //在点聚合中添加了
        let intro = item.intro || item.title;
        const opts = {
          position: point, // 指定文本标注所在的地理位置
          offset: new BMap.Size(-(intro.length + 1) * 6.7 - 5, -75)
        };
        const label = new BMap.Label(intro, opts);
        label.name = intro;
        label.type = item.type;
        label.setStyle({
          backgroundColor: "#fff",
          color: "#666",
          fontSize: "15px",
          padding: "4px 12px",
          borderRadius: "4px",
          border: "1px solid #ddd",
          boxShadow: "0px 4px 15px 0px rgba(185, 181, 181, 0.4)"
        });
        this.labels.push(label);

        marker.addEventListener("onmouseover", () => {});
        marker.addEventListener("onmouseout", () => {});

        /** 选择标注弹窗 */
        marker.addEventListener("click", () => {
          this.ifSetCenter = false; // 关闭地图自动设置中心点
          if(this.type == 5) { //党建地图无详情
            return;
          }
          openUrl(this.$router, {
            path: "/map/detail",
            query: {
              name: item.name || item.title,
              type: this.type,
              // id: item.id
            }
          })
        });
      });

      /**聚类功能，
       * 地图缩放到最大限度时 更改最小的聚合数量（否则剩余聚合点无法打开 ps:暂定20 如还有更大聚合点 可更改）
       * */
      let currentZoom = this.map.getZoom();
      if (currentZoom >= 19) {
        this.markerClusterer.setMinClusterSize(20);
      } else this.markerClusterer.setMinClusterSize(5);

      let lenn = this.labels.length;
      this.markerClusterer.addMarkers(this.markers, this.labels);
    }
  },

  watch: {
    type(val, old) {
      this.changeType = true;
      this.markerClusterer.setStyles([this.clusterStyle]);
      this.differMarksList = []; // 消除查重条件
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.markers = [];
      this.labels = [];
      this.map.clearOverlays();
      this.markerClusterer.clearMarkers();

      this.map.centerAndZoom(new BMap.Point(114.9, 25.9), 10);

      // 区域描边
      this.map.addOverlay(this.polygon);

      this.timer = null;
      this.getData(true);
    },
    name(val, old) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = null;
      this.getData();
    }
  }
};
